import { render, staticRenderFns } from "./gRow.vue?vue&type=template&id=577eb0f1&scoped=true&"
import script from "./gRow.vue?vue&type=script&lang=js&"
export * from "./gRow.vue?vue&type=script&lang=js&"
import style0 from "./gRow.vue?vue&type=style&index=0&id=577eb0f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577eb0f1",
  null
  
)

export default component.exports